"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _uuid = require("uuid");
var _cookiesUtil = require("./cookiesUtil");
var TRACKING_SESSION_ID = 'tracking_session_id';
function read() {
  return _jsCookie["default"].get(TRACKING_SESSION_ID);
}
function create() {
  var cookieDomain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _cookiesUtil.TYPEFORM_DOMAIN;
  var id = _jsCookie["default"].get(TRACKING_SESSION_ID) || (0, _uuid.v4)();
  var inThirtyMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);
  _jsCookie["default"].set(TRACKING_SESSION_ID, id, {
    expires: inThirtyMinutes,
    domain: cookieDomain
  });
  return id;
}
function remove() {
  _jsCookie["default"].remove(TRACKING_SESSION_ID);
}
var sessionUtil = {
  read: read,
  createOrUpdate: create,
  remove: remove
};
var _default = exports["default"] = sessionUtil;